import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import "../styles/Hero.scss";

const navItems = [
  { id: "#about", label: "About" },
  { id: "#work", label: "Work" },
  { id: "#skills", label: "Skills" },
  { id: "#experience", label: "Experience" },
  { id: "#contact", label: "Connect" },
];

const transition = { duration: 1, ease: [.25, .1, .25, 1] };
const variants = {
  hidden: { filter: "blur(10px)", transform: "translateY(20%)", opacity: 0 },
  visible: { filter: "blur(0)", transform: "translateY(0)", opacity: 1 },
};

const text = "Matt Alter";
const words = text.split(" ");

const Hero = () => {
  const [menuOpen, setMenuOpen] = useState(false);


  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    document.body.classList.remove("no-scroll");
    const section = document.querySelector(targetId);

    if (section) {
      const offsetTop = section.offsetTop;
      window.scrollTo({ top: offsetTop, behavior: "smooth" });
    }
  };
  // Lock page scroll when menu is open
  useEffect(() => {
    if (menuOpen) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
    return () => document.body.classList.remove("no-scroll");
  }, [menuOpen]);


  const listVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.08,
        delayChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: {
      opacity: 0,
      x: 24,
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.35,
        ease: "easeOut",
      },
    },
  };

  return (
    <section className="hero">
      {/* Mobile hamburger */}
      <button
        className={`mobile-nav-toggle ${menuOpen ? "open" : ""}`}
        aria-label="Toggle menu"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <span className="hamburger" />
      </button>

      {/* Fullscreen Mobile Menu */}
      <motion.div
        className={`mobile-nav ${menuOpen ? "open" : ""}`}
        initial={{ opacity: 0, y: -20 }}
        animate={menuOpen ? { opacity: 1, y: 0 } : { opacity: 0, y: -20 }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
      >
        <ul>
          {navItems.map((item) => (
            <motion.li
              key={item.id}
              initial={{ opacity: 0, y: 20 }}
              animate={menuOpen ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
              transition={{ duration: 0.8, ease: "easeInOut", delay: menuOpen ? 0.1 : 0 }}
            >
              <a
                href={item.id}
                onClick={(e) => {
                  handleNavClick(e, item.id);
                  setMenuOpen(false);
                }}
              >
                {item.label}
              </a>
            </motion.li>
          ))}
        </ul>
      </motion.div>

      <div className="hero-container">
        <div className="hero-content">
          <motion.div
            initial="hidden"
            animate="visible"
            transition={{ staggerChildren: 0.04 }}
          >
            <h1 className="mb-6 text-5xl font-semibold md:text-6xl text-white">
              {words.map((word, wordIndex) => (
                <React.Fragment key={wordIndex}>
                  {word.split("").map((letter, letterIndex) => {
                    const isFirstLetter = letterIndex === 0;
                    return (
                      <motion.span
                        key={letterIndex}
                        className="inline-block"
                        transition={transition}
                        variants={{
                          hidden: isFirstLetter
                            ? { opacity: 0, scale: 0.8 }
                            : { opacity: 0, x: -10 },
                          visible: isFirstLetter
                            ? { opacity: 1, scale: 1 }
                            : { opacity: 1, x: 0 },
                        }}
                      >
                        {letter}
                      </motion.span>
                    );
                  })}
                  {wordIndex < words.length - 1 && " "}
                </React.Fragment>
              ))}
            </h1>
            <motion.p className="text-zinc-400 text-md mb-8" transition={transition} variants={variants}>
              I am a Frontend Developer and Design Engineer, dedicated to architecting cutting-edge, scalable design systems and intuitive user interfaces that elevate products, amplify brand identity, and redefine user experiences.
            </motion.p>
          </motion.div>
        </div>
        <div className="nav desktop-nav">
          <motion.ul
            variants={listVariants}
            initial="hidden"
            animate="visible"
          >
            {navItems.map((item) => (
              <motion.li key={item.id} variants={itemVariants}>
                <motion.a
                  href={item.id}
                  className="nav-links"
                  onClick={(e) => handleNavClick(e, item.id)}
                >
                  <span />
                  {item.label}
                </motion.a>
              </motion.li>
            ))}
          </motion.ul>
        </div>
      </div>
    </section>
  );
};

export default Hero;
